// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"886":"5d88fb8c","902":"c5876da1"}[chunkId] + ".chunk.css";
};